import { shouldForwardProp } from '@ori/presentation-utils';
import { styled } from '@ori-ui/mui';
export var Img = styled('img', {
  shouldForwardProp: shouldForwardProp()
})(function (_ref) {
  var isPlaceholderVisible = _ref.isPlaceholderVisible;
  return {
    display: isPlaceholderVisible ? 'none' : 'inherit'
  };
});
//# sourceMappingURL=styles.js.map